import { render } from "./TaskDetails.vue?vue&type=template&id=66079d82"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__